import { create } from 'zustand';

export interface LoginStore {
  error: string | null;
  setError: (error: string | null) => void;
  clearError: () => void;
}

/**
 * Zustand stores are module-level and already survive HMR remounts.
 * No sessionStorage persistence - we rely on the location effect in LoginPage
 * to clear errors on actual navigation.
 */
export const useLoginStore = create<LoginStore>((set: (state: Partial<LoginStore>) => void) => ({
  error: null,
  setError: (error: string | null) => {
    set({ error });
  },
  clearError: () => {
    set({ error: null });
  },
}));

